<template>
  <div class="form" style="text-align:left;">
    <div class="title is-4">{{title}}</div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <produktionsverfahrenselect :selected="item.gameProductions" @input="setGameProductions($event)"></produktionsverfahrenselect>
      </div>
      <div class="column">

      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Gestaltungsleitfaden">
          <b-input size="is-small" readonly="true" v-model="item.gestaltungsleitfaden"></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <label class="label is-dashed" v-tooltip="getHtmlGameTooltip()">Spiel</label>
        <gameselect :selectedgame="item.game" @input="setGame($event)"></gameselect>
      </div>
      <div class="column">
        <label class="label">Umfang</label>
        <itemselect :selectedumfang="item.item" @input="setItem($event)"></itemselect>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <label class="label">Format</label>
        <formatselect :selectedformat="item.format" @input="setFormat($event)"></formatselect>
      </div>
      <div class="column">
        <label class="label">Verpackungen</label>
        <packageselect :selectedpackages="item.packages" @input="setNewPackages($event)"></packageselect>
      </div>
    </div>


    <div class="columns">
      <div class="column" style="text-align:right;">
        <b-button type="is-primary" v-on:click="save()" :disabled="loading">Speichern</b-button>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import gameselect from "@/components/GameSelect.vue";
import packageselect from "@/components/PackageSelect.vue";
import formatselect from "@/components/FormatSelect.vue";
import itemselect from "@/components/ItemSelect.vue";
import produktionsverfahrenselect from "@/components/ProduktionsVerfahrenSelect.vue";


import Vue from 'vue'
import VTooltip from 'v-tooltip'

const axios = require('axios');

Vue.use(VTooltip)

export default {
  name: "home",
  components: {
    gameselect,
    packageselect,
    formatselect,
    itemselect,
    produktionsverfahrenselect
},
data() {
      return {
          title: "Neue Spiel-Kombi anlegen",
          item: {},
          loading: true,
        //  item: { 'id': 22, 'name': 'Beidseitig individuelles Kartenset', 'spielart': 'Kartenspiel', 'date': '2016-10-15 13:43:27' },
      }
  },
  watch: {

  },
  mounted: function() {
    console.log("FORM "+ this.$route.params.id);
    if (this.$route.params.id) {
      this.title = "Spiel-Kombi bearbeiten";
      //Get-Game
      var _this = this;
      axios.get('/api/gamecombinations/'+this.$route.params.id, {
        withCredentials: true,
      })
      .then(function (response) {
        console.log(response.data);
        _this.item = response.data;
        _this.loading = false;

      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function () {
        // always executed
      });
    } else {
      this.loading = false;
    }

  },
  methods: {
    setGame: function(val) {
      console.log("setGame");
      console.log(val);
      this.$set(this.item, "game", val)
    },
    setItem: function(val) {
      console.log("setItem");
      console.log(val);
      this.$set(this.item, "item", val)
    },
    setFormat: function(val) {
      console.log("setFormat");
      console.log(val);
      this.$set(this.item, "format", val)
    },
    setNewPackages: function(val) {
      console.log("setpackages");
      console.log(val);
      this.$set(this.item, "packages", val)
    },
    setGameProductions: function(val) {
      console.log("setGameProductions");
      console.log(val);
      this.$set(this.item, "gameProductions", val)
    },
    getHtmlGameTooltip: function() {
      var html = "";
      if (this.item.game) {
        html += "<img style='max-width:150px;height:auto' src="+this.item.game.smallEditionImage+" /><br/>";
        html += "<b>Name:</b> "+this.item.game.name+"<br/>";
        html += "<b>Code:</b> "+this.item.game.code+"<br/>";
        html += "<b>Spielart:</b> "+this.item.game.category.name+"<br/>";
        html += "<b>Beschreibung:</b> "+this.item.game.description+"<br/>";
      }
      return html;
    },
    save: function() {

      //Validation
      if ((this.item.gameProductions) && (this.item.game) && (this.item.item) && (this.item.format) && (this.item.packages)){
      //Set-Game
      var _this = this;
      var url = '/api/gamecombinations';

        //this.item.id = null;
        //this.item.errormsg = "";
        //this.item.gameProductions = empyGameProduction;


      console.log("SAVE");
      console.log(url);
      console.log(this.item);

      axios.post(url, this.item, {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      })
      .then(function (response) {
        console.log(response.data);
        _this.$router.push({ name: 'gamescombi' })
      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function () {
        // always executed
      });
    } else {
      console.log("Alle Felder ausfüllen");
      this.$buefy.dialog.alert({
                    title: 'Fehler',
                    message: 'Bitte selektieren Sie alle Auswahlfelder. Mindestens ein Produktionsverfahren muss ausgefüllt sein.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'alert-circle',
                    iconPack: 'mdi'
                });
    }
    }
  }
};

</script>
